import { ReactNode } from "react";
import { useProductListManagerContext } from "./ProductListManagerContainer";
import { OpwContextProvider } from "./add/form/OpwContext";

const OpwContextProviderWrapper = ({ children }: { children: ReactNode }) => {
  const { products, uatProducts, allowDebitCardRequiredByProduct } = useProductListManagerContext();

  return (
    <OpwContextProvider
      allProducts={products}
      uatProducts={uatProducts}
      allowDebitCardRequiredByProduct={allowDebitCardRequiredByProduct}
    >
      {children}
    </OpwContextProvider>
  );
};

export default OpwContextProviderWrapper;
